module.exports = __webpack_public_path__ + "static/media/saas-advantage-icon-2.931a7722.png";